import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no travel to Seattle needed",
      "Ideal for Boise State University students studying abroad",
      "Perfect for Micron and Simplot professionals on overseas assignments",
      "Great for BOI international flyers",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Ada County post offices",
      "Good for planned international trips from Boise",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Boise area facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Seattle — ~500 miles via I-84/I-90",
      "NPIC appointment required before flying or driving to Seattle",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Air travel to Seattle typically required — impractical drive",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Boise"
      headingExtra="ID"
      introText="Boise and Treasure Valley travelers — Boise State University students studying abroad, Micron and Simplot professionals on overseas assignments, Boise Airport (BOI) international flyers, and Idaho outdoor adventure companies sending guides abroad — have several options for getting a passport fast. Here is how they compare, and why most Idaho residents choose a U.S. Department of State registered passport courier for predictable, professional processing — especially since the closest regional passport agency is 500 miles away in Seattle."
      options={options}
      emergencyDescription="Boise does not have its own regional passport agency, and there is no passport agency in the entire state of Idaho. The closest agency is in Denver — approximately 800 miles away via I-84 through Utah and Wyoming to I-25. Driving takes 12+ hours one way, so air travel is typically required. You must obtain an NPIC appointment before traveling, and walk-ins are not accepted at the Denver Passport Agency."
      disclaimerText="*Processing speed depends on eligibility and documentation. Idaho has no regional passport agency — the closest is Seattle, roughly 500 miles and 8+ hours driving away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}